import { Menu, MenuProps } from "@mui/material";
import { menuStyles } from "./Styles";

const StyledMenu = ({ children, ...props }: MenuProps) => (
  <Menu sx={menuStyles} {...props}>
    {children}
  </Menu>
);
export default StyledMenu;
